import { List, Map } from 'immutable';

import { OPERATIONS } from '../../../../constants/bulkEdit';
import { VALUE } from '../../../../constants/product';
import { EMPTY } from '../../../../constants';
import ATTRIBUTE from '../../../../constants/attributes';

export function price({ channel, preview }) {
  const payload = [];

  if (preview.hasIn([ATTRIBUTE.PRICE, 'operation'])) {
    payload.push(
      Map({
        type: preview.getIn([ATTRIBUTE.PRICE, 'operation']),
        value: preview.getIn([ATTRIBUTE.PRICE, 'conversion'])
          ? List([EMPTY.MAP])
          : List([
            Map({
              combination: null,
              offeringId: null,
              value: Map({
                rounding: preview.getIn([ATTRIBUTE.PRICE, VALUE, 'cents']),
                type: preview.getIn([ATTRIBUTE.PRICE, VALUE, 'price_type']),
                value: preview.getIn([ATTRIBUTE.PRICE, VALUE, VALUE]),
              }),
            }),
          ]),
      })
    );
  }

  if (preview.hasIn([ATTRIBUTE.PRICE, ATTRIBUTE.CHARGE_TAX])) {
    payload.push(
      Map({
        type: OPERATIONS[channel].CHARGE_TAX.SET,
        value: List([
          Map({
            combination: null,
            offeringId: null,
            value: Map({
              taxable: preview.getIn([ATTRIBUTE.PRICE, ATTRIBUTE.CHARGE_TAX]),
            }),
          }),
        ]),
      })
    );
  }

  return { payload };
}
